import axios from "axios";

export default function RolegroupRolesRolesService(formData, groupId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/role_group/" + groupId + "/roles",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
